import emptyAgenda800 from "@/assets/empty-agenda-800.webp";
import emptyAgenda1400 from "@/assets/empty-agenda-1400.webp";
import { TextLink } from "@/components/ui/Button";
import { QUIZ_PATH } from "@/config/constants";
import { useContent } from "@/data/content";
import { useAppTranslation } from "@/i18n/useAppTranslation";

export function ProblemSection() {
  const { problem } = useContent().home;
  const { t } = useAppTranslation("common");
  return (
    <section aria-labelledby="problem-heading" className="relative bg-brand-bg">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-24 sm:px-6 md:py-32 lg:grid-cols-[1.25fr_1fr] lg:gap-20 lg:px-8">
        {/* The headline sits over an open, empty agenda: the problem, pictured. */}
        <div className="relative isolate flex min-h-[26rem] overflow-hidden rounded-[1.75rem] shadow-lit lg:min-h-[30rem]">
          <img
            src={emptyAgenda1400}
            srcSet={`${emptyAgenda800} 800w, ${emptyAgenda1400} 1400w`}
            sizes="(min-width: 1024px) 55vw, 100vw"
            alt=""
            width={1400}
            height={764}
            loading="lazy"
            decoding="async"
            className="absolute inset-0 -z-10 size-full object-cover object-[50%_75%]"
          />
          <span
            aria-hidden="true"
            className="absolute inset-0 -z-10 bg-[linear-gradient(180deg,rgb(249_249_249/0.96)_0%,rgb(249_249_249/0.9)_38%,rgb(249_249_249/0.35)_72%,rgb(249_249_249/0.05)_100%)]"
          />
          <h2
            id="problem-heading"
            data-reveal=""
            className="self-start px-7 pb-40 pt-8 font-display text-[clamp(2rem,4.2vw,3.4rem)] font-semibold leading-[1.1] tracking-[-0.02em] text-brand-primary sm:px-10 sm:pt-10"
          >
            {problem.title}
          </h2>
        </div>

        <div className="lg:pt-3">
          <ul>
            {problem.lines.map((line, i) => (
              <li
                key={i}
                data-reveal=""
                style={{ ["--reveal-delay" as string]: `${i * 90}ms` }}
                className="group/pain flex gap-5 border-t border-brand-primary/10 py-6 first:border-t-0 first:pt-0"
              >
                <span aria-hidden="true" className="mt-[0.9rem] h-0.5 w-7 shrink-0 origin-left rounded-full bg-brand-secondary transition-transform duration-500 ease-[var(--ease-out-expo)] group-hover/pain:scale-x-150" />
                <span className="text-lg leading-relaxed text-ink-soft">{line}</span>
              </li>
            ))}
          </ul>
          <p
            data-reveal=""
            style={{ ["--reveal-delay" as string]: "300ms" }}
            className="mt-8 rounded-2xl bg-brand-primary px-6 py-5 font-display text-xl font-semibold leading-snug text-white sm:text-2xl"
          >
            {problem.conclusion}
          </p>
          <div data-reveal="" style={{ ["--reveal-delay" as string]: "380ms" }} className="mt-6">
            <TextLink to={QUIZ_PATH}>{t("quizCta")}</TextLink>
          </div>
        </div>
      </div>
    </section>
  );
}
